<template>
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path
      class="st0"
      d="M12,22c5.5,0,10-4.5,10-10S17.5,2,12,2S2,6.5,2,12S6.5,22,12,22z M7.9,11H16c0.5,0,1,0.4,1,0.9s-0.4,0.9-1,0.9
	H7.9c-0.5,0-0.9-0.4-0.9-0.9S7.4,11,7.9,11z"
    />
    <path
      class="st1"
      d="M12,22c5.5,0,10-4.5,10-10S17.5,2,12,2S2,6.5,2,12S6.5,22,12,22z M7.9,11H16c0.5,0,1,0.4,1,0.9s-0.4,0.9-1,0.9
	H7.9c-0.5,0-0.9-0.4-0.9-0.9S7.4,11,7.9,11z"
    />
  </svg>
</template>
